import { Component } from '@angular/core';

@Component({
  imports: [],
  selector: 'app-notfound',
  styleUrl: './notfound.component.css',
  templateUrl: './notfound.component.html',
})
export class NotfoundComponent {}
